<template>
    <el-header class="s_layout_header" height="50px">
        <div class="tabs">
            <!-- 收缩 -->
            <div class=" g-flex-justify-center g-flex-align-center fold" v-if="false" @click="$emit('collapse')">
                <SvgIcon :class="{'fold-active':!isCollapse}" name="fold" />
            </div>

            <el-tabs class="substance" v-model="tabPath" type="card" closable @tab-click="clickTab" @tab-remove="removeTab">
                <el-tab-pane v-for="item in tabsList" :key="item.path" :label="item.title" :name="item.path"></el-tab-pane>
            </el-tabs>
            <div class="screenfull" @click="clickFullscreen">
                <SvgIcon :name="isFullscreen?'exit-fullscreen':'fullscreen'" />
            </div>
            <el-dropdown trigger="click" @command="handleCommand">
                  <span class="s-exit-box">
                     <SvgIcon class="icon-exit" name="exit" />
                      <!-- <i class="el-icon-caret-bottom"></i> -->
                  </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="cleanData" v-if="$global.adminUser.type === 4"><span>清理缓存</span></el-dropdown-item>
                    <el-dropdown-item command="loginOut" :divided="$global.adminUser.type === 4 ? true: false"><span>退出登陆</span></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </el-header>
</template>

<script>
    import screenfull from  'screenfull'
    import { apiLogout, apiClearCache } from '@/utils/api.js'
    export default {
        name: 'LayoutHeader',
        created() {
            //初始化标签
            this.addTab()
        },
        props: {
            //左侧菜单栏收缩
            isCollapse: {
                type:Boolean,
                default:false
            }
        },
        data(){
            return {
                isFullscreen: false,
                tabsList: [],
                tabPath: '',
            }
        },
        methods: {
            handleCommand(command) {
                if(command === 'loginOut') return this.loginOutClick()
                return this.apiClearCacheHandel()
            },

            async apiClearCacheHandel() {
                const { success, data } = await apiClearCache()
                if(!success) return
                this.$message.success(data.msg)
            },

            // 退出登录
            async loginOutClick() {
                const { success, data } = await apiLogout()
                if(!success) return
                this.$message.success(data.msg)
                this.$global.logout()
            },

            //添加标签
            addTab() {
                if(this.$route.path=='/refresh') return
                this.tabPath = this.$route.path
                if (this.tabsList.some(tab => tab.path === this.$route.path)) return
                this.tabsList.push({
                    title: this.$route.meta.title,
                    path: this.$route.path
                })
            },

            //删除Tab
            removeTab(tabPath) {
                //删除其他标签
                if (this.tabsList.length < 2) return this.$message.error('无法关闭最后一个Tab!')
                this.tabsList.some((tab, index) => {
                    if (tab.path === tabPath) {
                        //tabList删除
                        this.tabsList.splice(index, 1)
                        if (this.tabPath === tabPath) {
                            if (index === 0) {
                                //删除第一个标签,走第一个标签
                                this.tabPath = this.tabsList[0].path
                            } else {
                                //跳转前一个标签
                                this.tabPath = this.tabsList[index - 1].path
                            }
                            this.$router.push(this.tabPath)
                        }
                        return true
                    }
                    return false
                })
            },

            //点击Tab
            clickTab() {
                this.$router.push(this.tabPath).catch(()=>{
                    this.$router.replace('/refresh')
                })
            },
            //点击全屏
            clickFullscreen(){
                if (!screenfull.isEnabled) {
                    this.$message({
                        message: '当前浏览器不支持全屏',
                        type: 'warning'
                    })
                    return false
                }
                screenfull.toggle()
                this.isFullscreen = !this.isFullscreen
            }
        },
        watch: {
            $route() {
                this.addTab()
            }
        }
    }
</script>
<style lang="scss">
    .s_layout_header{
        background-color: #fff;
        color: #606266;
        line-height: 50px;
        font-size: 12px;
        border-bottom: 1px solid #d8dce5;
        box-shadow: 0 1px 4px rgba(0,21,41,.08);
        padding: 0;
        .el-tabs--card > .el-tabs__header {
            border-bottom: none;
        }
        .tabs{
            display: flex;
            width: 100%;
            height: 100%;
        }
        .substance{
            flex: 1;
            width: calc(100% - 160px);
        }
        .fold{
            width: 50px;
            height: 50px;
            font-size: 24px;
            color: #000;
            cursor: pointer;
        }
        .fold-active{
            transform: rotate(180deg);
        }
        .el-dropdown{
            cursor: pointer;
            margin-right: 20px;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            vertical-align: text-bottom;
        }
        .screenfull{
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            vertical-align: text-bottom;
            cursor: pointer;
        }
        .rabbit{
            width: 45px;
            height: 45px;
            border-radius: 10px;
        }
        .s-exit-box {
            padding: 0 30px;
            font-size: 30px;
            .icon-exit {
                color: $red;
            }
            .el-icon-caret-bottom{
                position: absolute;
                top: 25px;
                font-size: 12px;
                color: $red;
            }
        }

    }
</style>